export default function UnknownWeatherIcon({ className }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21 1H3V23H21V1Z"
        stroke="inherit"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
        fill="inherit"
      />
      <path
        d="M9.81152 6.55977C11.7915 5.68477 14.3535 5.78877 15.2285 7.20477C16.1035 8.62077 15.4995 10.2678 13.9995 11.5388C12.4995 12.8098 11.9995 13.4998 11.9995 14.4998"
        stroke="inherit"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
